import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmergencyAlert = ({ alert, onDismiss, onTakedown }) => {
  if (!alert) return null;

  return (
    <div className="bg-error/10 border border-error/20 rounded-lg p-4 mb-6">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <div className="p-2 bg-error/20 rounded-lg">
            <Icon name="AlertTriangle" size={20} className="text-error" />
          </div>
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-2">
            <h3 className="text-sm font-semibold text-error">EMERGENCY ALERT</h3>
            <span className="px-2 py-1 bg-error text-error-foreground rounded-full text-xs font-medium">
              CRITICAL
            </span>
          </div>
          
          <p className="text-sm text-foreground mb-3">
            {alert?.message}
          </p>
          
          <div className="flex items-center space-x-2 text-xs text-muted-foreground mb-4">
            <span>Content ID: {alert?.contentId}</span>
            <span>•</span>
            <span>Platform: {alert?.platform}</span>
            <span>•</span>
            <span>Detected: {alert?.detectedAt}</span>
          </div>
          
          <div className="flex items-center space-x-3">
            <Button
              variant="destructive"
              size="sm"
              iconName="Shield"
              iconSize={14}
              onClick={() => onTakedown(alert?.contentId)}
            >
              Emergency Takedown
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              iconSize={14}
            >
              Review Content
            </Button>
            
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              iconSize={14}
              onClick={() => onDismiss(alert?.id)}
            >
              Dismiss
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyAlert;